import React from 'react';
import { Table, Tabs, Descriptions, Button, Select } from 'antd';
import { withTranslation } from "react-i18next";
import axios from 'axios';
import i18n from "../../utils/i18n";
import config from '../../utils/config';
import {itemColumns, packColumns } from './utils';
import './index.css'
import TextArea from 'antd/lib/input/TextArea';
import { openErrorMsg, openSuccessMsg } from '../../utils/messageUtils';
import EdittableTable from './editableTable';



class SupplierQuotation extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            itemList: [],
            packList: [],
            infoData: null,
            transportData: null,
            quoList: [],
            queryParams: null,
            remark:'',
            loadding: false,
            promptMap: null,
            lang: ''
        }
        this.quoColumns = () => [
          {
            title: this.props.t('tms.export.inquiryQuoteDetailExportVO.field.costName', { defaultValue: this.state.promptMap ? this.state.promptMap['tms.export.inquiryQuoteDetailExportVO.field.costName'] : '费用名称' }),
            dataIndex: 'costName',
            key: 'costName',
          },
          {
            title: this.props.t('tms.export.inquiryQuoteDetailExportVO.field.priceType', { defaultValue: this.state.promptMap ? this.state.promptMap['tms.export.inquiryQuoteDetailExportVO.field.priceType'] : '价格类型' }),
            dataIndex: 'priceTypeName',
            key: 'priceTypeName',
          },
          {
            title: this.props.t('tms.export.inquiryQuoteDetailExportVO.field.currency', { defaultValue: this.state.promptMap ? this.state.promptMap['tms.export.inquiryQuoteDetailExportVO.field.currency'] : '币种' }),
            dataIndex: 'currency',
            key: 'currency',
          },
          {
            title:<><span style={{color: 'red', marginRight: '5px'}}>*</span><span>{this.props.t('tms.export.inquiryQuoteDetailExportVO.field.price', { defaultValue: this.state.promptMap ? this.state.promptMap['tms.export.inquiryQuoteDetailExportVO.field.price'] : '价格' })}</span></>,
            dataIndex: 'price',
            key: 'price',
            width: 300,
            editable: true,
            label:props.t('tms.export.inquiryExportVO.msg.submitRegex', { defaultValue: this.state.promptMap ? this.state.promptMap['tms.export.inquiryExportVO.msg.submitRegex'] : '报价价格最多保留两位小数，请检查！'  }),
            // render: (text, record,index) =>{
            //   return (
            //     <InputNumber value={text} precision={2} onChange={(value)=>{this.onPriceChage(value, record, index)}} style={{width: '200px'}}  />
            //   )
            // }
          },
          {
            title: this.props.t('tms.export.inquiryQuoteDetailExportVO.field.totalPrice', { defaultValue: this.state.promptMap ? this.state.promptMap['tms.export.inquiryQuoteDetailExportVO.field.totalPrice'] : '总价' }),
            dataIndex: 'totalPrice',
            key: 'totalPrice',
            render: (text, record, index) => {
              return <span>{record?.totalPrice}</span>
            }
          },
          
        ]
    }

    tableRef = React.createRef();



    componentDidMount() {

      const queryString = this.props.history.location.search;
      // 去除前导问号，如果存在
      const cleanQueryString = queryString.startsWith('?') ? queryString.substring(1) : queryString;
      const params = new URLSearchParams(cleanQueryString);
      // 创建一个对象存储解析的参数
      const queryParams = {};

      params.forEach((value, key) => {
          queryParams[key] = value;
      });
      const lang = localStorage.getItem('lang') || 'en_US';
      if(lang !=='zh_CN'){
        document.title = 'Sany TMS'
      }
      this.getDetail(queryParams);
      this.setState({queryParams, lang: localStorage.getItem('lang') || 'en_US'})

    }
    getDetail = (queryParams) =>{
      const params = {
        carrierId: queryParams?.carrierId,
        lang: localStorage.getItem('lang') || 'en_US',
        transportRequireId: queryParams?.transportRequireId,
      }
      axios
      .get(`${config.API_HOST}/transport/v1/2/inquiry/${queryParams?.inquiryId}`,{params})
      .then((res) => {
          if(res?.data){
            this.setState({
              itemList: res.data.inquiryItemList,
              packList: res.data.inquiryPackList,
              infoData: res.data,
              transportData: res.data.inquiryTransportRequireList[0],
              quoList: res.data.inquiryTransportRequireList[0]?.inquiryQuoteDetailList,
              promptMap: res.data.promptMap
            });
            
          }
      })
      .catch((err) => {
          console.log(err);
      });
    }

    onChange = (key) => {
      console.log(key);
    };

    tableFooter = (pageData) => {
      let totalQuantity = 0;
      let totalGrossWeight = 0;
      let totalNetWeight = 0;
      let totalVolume = 0;
      pageData.forEach(({ quantity, grossWeight, netWeight, volume }) => {
        totalQuantity += quantity;
        totalGrossWeight += grossWeight;
        totalNetWeight += netWeight;
        totalVolume += volume;
      });
  
      return (
        <Table.Summary fixed>
          <Table.Summary.Row>
            <Table.Summary.Cell index={0}>{this.props.t('tms.export.inquiryExportVO.field.totalCount', { defaultValue: this.state.promptMap ? this.state.promptMap['tms.export.inquiryExportVO.field.totalCount'] : '总计：' })}</Table.Summary.Cell>
            <Table.Summary.Cell index={1}>{totalQuantity}</Table.Summary.Cell>
            <Table.Summary.Cell index={2}>{totalGrossWeight}</Table.Summary.Cell>
            <Table.Summary.Cell index={3}>{totalNetWeight}</Table.Summary.Cell>
            <Table.Summary.Cell index={4}>{totalVolume}</Table.Summary.Cell>
            <Table.Summary.Cell index={5}></Table.Summary.Cell>
            <Table.Summary.Cell index={6}></Table.Summary.Cell>
            <Table.Summary.Cell index={7}></Table.Summary.Cell>
            <Table.Summary.Cell index={8}></Table.Summary.Cell>
          </Table.Summary.Row>
        </Table.Summary>
      );
  }

    items = () => [
      {
        key: '1',
        label: this.props.t('tms.export.inquiryExportVO.field.goodsInfo', { defaultValue: this.state.promptMap ? this.state.promptMap['tms.export.inquiryExportVO.field.goodsInfo'] : '货品明细' }),
        children: <Table pagination={false} dataSource={this.state.itemList} columns={itemColumns(this.props, this.state.promptMap)} footer={null} summary={this.tableFooter} />,
      },
      {
        key: '2',
        label: this.props.t('tms.export.inquiryExportVO.field.packDetails', { defaultValue: this.state.promptMap ? this.state.promptMap['tms.export.inquiryExportVO.field.packDetails'] : '包装明细' }),
        children:  <Table pagination={false} dataSource={this.state.packList} columns={packColumns(this.props, this.state.promptMap)} footer={null} summary={this.tableFooter} />,
      },
    ];


    onPriceChage = (value, record, index) =>{
      const data = this.state.quoList;
      data[index].totalPrice = value;
      this.setState({price: value})
      data[index].price = value;
      // setTimeout(()=>{
      //   this.setState({quoList: data})
      // },1000)
      
    }

    remarkChange = (value) =>{
      this.setState({quoList: this.tableRef.current.getList()}, ()=>{
        this.setState({remark: value.target.value})
      })
    }

    confirmQuote = () =>{
      // console.log('this----', this.tableRef.current.getList());
      // if(true) return;
      this.setState({quoList: this.tableRef.current.getList()}, ()=>{
        this.submit();
      })
      
    }

    submit = () =>{
      const {quoList} = this.state;
      let flag = false;
      quoList.forEach((item) => {
        if(item?.price){
          const regex = /^(([1-9]{1}\d*)|(0{1}))(\.\d{1,2})?$/;
          if(!regex.test(item.price)){
            flag = true;
          }
        }
      })
      if(flag){
        openErrorMsg(
          this.props.t('tips', { defaultValue: '提示' }), 
          this.props.t('tms.export.inquiryExportVO.msg.submitRegex', { defaultValue: this.state.promptMap ? this.state.promptMap['tms.export.inquiryExportVO.msg.submitRegex'] : '报价价格最多保留两位小数，请检查！'  })
        );
        return;
      }
      const { queryParams } = this.state;
      const params = {
        inquiryId: queryParams?.inquiryId,
        carrierId: queryParams?.carrierId,
        transportRequireId: queryParams?.transportRequireId,
        inquiryQuoteDetailList: this.state.quoList,
        quoteRemark: this.state.remark,
        lang: localStorage.getItem('lang') || 'en_US',
        carrierEmail: queryParams?.carrierEmail,
        uniqueKey: queryParams?.uniqueKey
      }
      this.setState({loadding: true});
      axios
      .post(`${config.API_HOST}/transport/v1/2/inquiry/confirm-quote`,params)
      .then((res) => {
        this.setState({loadding: false});
        if(res.data && res.data.failed){
          openErrorMsg(
            this.props.t('tips', { defaultValue: '提示' }), 
            res.data.message
          );
          return;
        }
        console.log('res111--',res);
        openSuccessMsg(
          this.props.t('tips', { defaultValue: '提示' }), 
          this.props.t('tms.export.inquiryExportVO.field.quoSuccess', { defaultValue: this.state.promptMap ? this.state.promptMap['tms.export.inquiryExportVO.field.quoSuccess'] : '报价成功！'  })
        );
        this.getDetail(this.state.queryParams);
      })
      .catch((err) => {
          this.setState({loadding: false});
      });
    }

    handleChange = (e) =>{
      // i18n.changeLanguage(e);
      let type = e
      if(e === 'en_US'){
        type = 'en'
      }else if(e === 'en_ID'){
        type = 'ina'
      }else if(e === 'zh_CN'){
        type = 'zh'
      } 
      localStorage.setItem('languageType', type);
      localStorage.setItem('lang', e);
      i18n.changeLanguage(type);
      this.setState({lang: e}, () => {
        // this.getDetail(this.state.queryParams)
        window.location.reload()
      })
    }

    render() {
        const { infoData,  transportData} = this.state;
        console.log('list---', this.state.quoList);
        return (
        <div className='table-div'>
          <div style={{display: 'flex', justifyContent: 'space-between'}}>
            <div>
              <h1>{infoData ? `【${infoData?.inquiryStatusName}】 ${infoData?.orgName} 
              ${this.props.t('tms.export.inquiryExportVO.field.inquiryQuo', { defaultValue: this.state.promptMap ? this.state.promptMap['tms.export.inquiryExportVO.field.inquiryQuo'] : '意向询价单'  })} 
              ${infoData?.inquiryNo}` : ''}</h1>
            </div>
            <div>
              <Select
                // defaultValue={this.state.lang}
                // style={{ width: 120 }}
                value={this.state.lang}
                onChange={this.handleChange}
                options={[
                  { value: 'zh_CN', label: '中文(CN)' },
                  { value: 'en_US', label: 'English' },
                  { value: 'en_ID', label: 'Indonesia' },
                  { value: 'fr_FR', label: 'Français'},
                  { value: 'es_ES', label: 'Español'},
                  { value: 'th_TH', label: 'ภาษาไท'},
                  { value: 'ru_RU', label: 'Русский'},
                  { value: 'ms_MS', label: 'Melayu'},
                  { value: 'pt_PT', label: 'Português'},
                  { value: 'vi_VI', label: 'Tiếng Việt'},
                  { value: 'ar_AR', label: 'اللغة العربية'},
                ]}
              />
            </div>
          </div>
          
          <Tabs defaultActiveKey="1" items={this.items()} onChange={this.onChange} />
          <Descriptions title={this.props.t('tms.export.inquiryExportVO.field.receiveSendInfo', { defaultValue: this.state.promptMap ? this.state.promptMap['tms.export.inquiryExportVO.field.receiveSendInfo'] : '收发货信息'  })} className='div-margin' >
            <Descriptions.Item label={this.props.t('tms.export.inquiryExportVO.field.sendCompanyName', { defaultValue: this.state.promptMap ? this.state.promptMap['tms.export.inquiryExportVO.field.sendCompanyName'] : '发货公司'  })}>{infoData?.sendCompanyName}</Descriptions.Item>
            <Descriptions.Item label={this.props.t('tms.export.inquiryExportVO.field.sendCountryName', { defaultValue: this.state.promptMap ? this.state.promptMap['tms.export.inquiryExportVO.field.sendCountryName'] : '发货国家'  })}>{infoData?.sendCountryName}</Descriptions.Item>
            <Descriptions.Item label={this.props.t('tms.export.inquiryExportVO.field.sendAddress', { defaultValue: this.state.promptMap ? this.state.promptMap['tms.export.inquiryExportVO.field.sendAddress'] : '发货详细地址'  })}>{infoData?.sendAddress}</Descriptions.Item>
            <Descriptions.Item label={this.props.t('tms.export.inquiryExportVO.field.receiveCompanyName', { defaultValue: this.state.promptMap ? this.state.promptMap['tms.export.inquiryExportVO.field.receiveCompanyName'] : '收货公司'  })}>{infoData?.receiveCompanyName}</Descriptions.Item>
            <Descriptions.Item label={this.props.t('tms.export.inquiryExportVO.field.receiveCountryName', { defaultValue: this.state.promptMap ? this.state.promptMap['tms.export.inquiryExportVO.field.receiveCountryName'] : '收货国家'  })}>{infoData?.receiveCountryName} </Descriptions.Item>
            <Descriptions.Item label={this.props.t('tms.export.inquiryExportVO.field.receiveAddress', { defaultValue: this.state.promptMap ? this.state.promptMap['tms.export.inquiryExportVO.field.receiveAddress'] : '收货详细地址'  })}>{infoData?.receiveAddress}</Descriptions.Item>
          </Descriptions>
          <Descriptions title={this.props.t('tms.export.inquiryExportVO.field.transportRequire', { defaultValue: this.state.promptMap ? this.state.promptMap['tms.export.inquiryExportVO.field.transportRequire'] : '运输要求'  })} className='div-margin'>
            <Descriptions.Item label={this.props.t('tms.export.inquiryQuoteDetailExportVO.field.transportType', { defaultValue: this.state.promptMap ? this.state.promptMap['tms.export.inquiryQuoteDetailExportVO.field.transportType'] : '运输方式'  })}>{transportData?.transportTypeName}</Descriptions.Item>
            <Descriptions.Item label={this.props.t('tms.export.inquiryQuoteDetailExportVO.field.stowageType', { defaultValue: this.state.promptMap ? this.state.promptMap['tms.export.inquiryQuoteDetailExportVO.field.stowageType'] : '配载方式'  })}>{transportData?.stowageTypeName}</Descriptions.Item>
            <Descriptions.Item label={this.props.t('tms.export.inquiryQuoteDetailExportVO.field.tradeTerms', { defaultValue: this.state.promptMap ? this.state.promptMap['tms.export.inquiryQuoteDetailExportVO.field.tradeTerms'] : '贸易术语' })}>{transportData?.tradeTerms}</Descriptions.Item>
            <Descriptions.Item label={this.props.t('tms.export.inquiryQuoteDetailExportVO.field.requireReceiveTime', { defaultValue: this.state.promptMap ? this.state.promptMap['tms.export.inquiryQuoteDetailExportVO.field.requireReceiveTime'] : '要求到货时间' })}>{transportData?.requireReceiveTime}</Descriptions.Item>
            <Descriptions.Item label={this.props.t('tms.export.inquiryExportVO.field.remarkB', { defaultValue: this.state.promptMap ? this.state.promptMap['tms.export.inquiryExportVO.field.remarkB'] : '备注' })}>{transportData?.remark} </Descriptions.Item>
          </Descriptions>
          <div className='ant-descriptions-title div-margin'>{this.props.t('tms.export.inquiryExportVO.field.detailQuo', { defaultValue: this.state.promptMap ? this.state.promptMap['tms.export.inquiryExportVO.field.detailQuo'] : '明细报价' })}</div>
          {/* <Table pagination={false} dataSource={this.state.quoList} columns={this.quoColumns()} footer={null} /> */}
          <EdittableTable ref={this.tableRef}  dataSource={this.state.quoList} columns={this.quoColumns()} />
          <div className='ant-descriptions-title div-margin'>{this.props.t('tms.export.inquiryQuoteDetailExportVO.field.remark', { defaultValue: this.state.promptMap ? this.state.promptMap['tms.export.inquiryQuoteDetailExportVO.field.remark'] : '报价备注' })}</div>
          <TextArea maxLength={500} rows={3} onChange={(value) =>this.remarkChange(value)} />
          <div style={{marginTop: '20px'}}>{this.props.t('tms.export.inquiryExportVO.field.loginCar', { defaultValue: this.state.promptMap ? this.state.promptMap['tms.export.inquiryExportVO.field.loginCar'] : '已录承运商：' })}{this.state.quoList[0]?.carrierName}</div>
          <div className='div-button'>
            <Button loading={this.state.loadding} onClick={this.confirmQuote} type='primary'>{this.props.t('tms.export.inquiryExportVO.field.confirmQuo', { defaultValue: this.state.promptMap ? this.state.promptMap['tms.export.inquiryExportVO.field.confirmQuo'] : '确认报价' })}</Button>
          </div>
        </div>
        )
    }
}

export default SupplierQuotation = withTranslation()(SupplierQuotation);